<template>
    <ProductCard
        product-type="hotel"
        :product-image="productData.info?.image_large_url"
        :product-link="hotelUrl"
        :product-name="productData.name"
        :product-stars-rating="productData.overview.rating_by_customers.outOfFiveFraction"
        :product-rating="productData.overview.rating_by_customers.accurate"
        :product-rating-count="productData.overview.surveys_count"
        :product-shuttle-free="productData.info?.shuttle_free"
        :product-shuttle-free-only="true"
        card-type="PackagesDealCard"
    />
</template>

<script setup lang="ts">
import ProductCard from '../cards/ProductCard.vue';
import type { IHotelProduct } from '@nuxt-monorepo/ui/types';

const { productData, blok } = defineProps<{ productData: IHotelProduct; blok: any }>();

const hotelUrl = computed(() => {
    let url = `/psf/${productData.slug}`;
    if (blok.source) {
        url = url + `?source=${blok.source}`;
    }
    return url;
});
</script>
